var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { on: { click: _vm.showDetail } }, [
    _c("img", {
      style: {
        width: "100%",
        height: "100%",
        "object-fit": _vm.objectFit
      },
      attrs: { src: _vm.url }
    }),
    _vm._v(" "),
    _vm.ifShowDetail
      ? _c(
          "div",
          {
            staticStyle: {
              "z-index": "999",
              position: "fixed",
              left: "0",
              top: "0",
              width: "100%",
              height: "100%",
              background: "#00000066",
              display: "flex",
              "align-items": "center"
            },
            on: {
              click: function($event) {
                $event.stopPropagation()
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.close($event)
              }
            }
          },
          [
            _c("img", {
              ref: "bigImg",
              staticStyle: {
                position: "relative",
                "transform-origin": "50% 50%",
                margin: "0 2%",
                width: "96%",
                "object-fit": "contain"
              },
              attrs: { src: _vm.url }
            })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }